import ActionCable from "actioncable";

export default ActionCable.createConsumer(SOCKET_URL);
